import React from 'react';
import { ImageErrorPlaceholder } from '@yme/atoms/image-error-placeholder';
import { useIsOnScreen } from '@yme/hooks/index';
import { buildKey } from '@yme/utils/common';
import { keyCodes } from '@yme/utils/constants';
import { getElementRef, getThumbnailType } from './helpers';
import { ThumbnailItemStyled, ThumbnailItemWrapperStyled, ThumbnailsStyled } from './styled';
import { useErrorItems } from './useErrorItems';
export function ThumbnailList({ items, onShowItem, amount, indent, isRightToLeft, currentIndex, thumbnailRef, isInLightbox, thumbnailAspectRatio, }) {
    const { addErrorItem, isErrorItem } = useErrorItems();
    const { isOnScreen, ref: lastRef } = useIsOnScreen();
    const keyDownHandler = (event, index) => {
        if (event.key === keyCodes.ENTER) {
            onShowItem(index);
        }
    };
    return (React.createElement(ThumbnailsStyled, { isOnScreen: isOnScreen, amount: amount, indent: indent, isRightToLeft: isRightToLeft }, items.map((item, index) => {
        const isActiveItem = index === currentIndex;
        const isItemLast = index === items.length - 1;
        const itemRef = getElementRef(isActiveItem, thumbnailRef);
        const type = getThumbnailType(item?.element?.props['data-type'], isInLightbox);
        return (React.createElement(ThumbnailItemWrapperStyled, { ref: isItemLast ? lastRef : null, isRightToLeft: isRightToLeft, amount: amount, indent: indent, key: buildKey('key', index) },
            React.createElement(ThumbnailItemStyled, { isActive: index === currentIndex, aspectRatio: thumbnailAspectRatio, onMouseUpCapture: () => onShowItem(index), onError: () => addErrorItem(index), ref: itemRef, role: "button", tabIndex: 0, onKeyDown: (event) => keyDownHandler(event, index), type: type }, isErrorItem(index) ? React.createElement(ImageErrorPlaceholder, null) : item.element)));
    })));
}
